(function () {
  'use strict';

  const btn = document.querySelector('.c-btnEntry');
  if (!btn) { return; }

  function scrollFunc() {
    //console.log('scroll', window.scrollY);
    //const scrollTop = window.scrollY;

    // mv or header
    const elmMv = document.querySelector('.page-career__mv');
    const elmH = document.querySelector('.l-header');
    let offsetH1 = -1;
    if (elmMv) {
      const mvBottom = elmMv.offsetTop + elmMv.offsetHeight;
      offsetH1 = window.scrollY - mvBottom;
    } else if (elmH) {
      const headerHeight = elmH.getBoundingClientRect().height;
      offsetH1 = window.scrollY - headerHeight;
    }
    //console.log(offsetH1);

    // cv or footer
    const elmCv = document.querySelector('.c-cvCareer');
    const elmF = document.querySelector('.l-footer');
    let offsetH2 = 1;
    if (elmCv) {
      offsetH2 = elmCv.getBoundingClientRect().top - window.innerHeight - 50;
    } else if(elmF) {
      offsetH2 = elmF.getBoundingClientRect().top - window.innerHeight - 50;
    }


    if (offsetH1 > 0 && offsetH2 > 0) {
      btn.classList.add('is-visible');
    } else if (offsetH2 > 0) {
      btn.classList.remove('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', () => {
    scrollFunc();
  });
  window.addEventListener('touchmove', () => {
    scrollFunc();
  });
  scrollFunc();


})();
